import React, { ReactNode } from 'react';
import { Card } from 'react-bootstrap';

type SelectItemInputProps = {
  value?: any;
  onChange?(value: any): void;
  options: any[];
  children(props: any, selected: boolean): ReactNode;
  noWrap?: boolean;
  wrapperProps?: any;
};
const SelectItemInput: React.FC<SelectItemInputProps> = ({
  children,
  options,
  onChange,
  value,
  wrapperProps,
  noWrap = false,
}) => {
  if (noWrap) {
    return (
      <>
        {options.map((option, index) => {
          const selected = value === option;
          return (
            <div
              role="button"
              key={option.id || index}
              className="mb-3"
              tabIndex={0}
              onKeyPress={() => (onChange ? onChange(option) : undefined)}
              style={{
                cursor: 'pointer',
                border: 'none',
                accentColor: 'white',
                background: 'none',
                outline: 'none',
                display: 'block',
              }}
              onClick={() => (onChange ? onChange(option) : undefined)}
              {...(wrapperProps || {})}
            >
              {children(option, selected)}
            </div>
          );
        })}
      </>
    );
  }
  return (
    <>
      {options.map((option, index) => {
        const selected = value === option;
        return (
          <Card
            key={option.id || index}
            style={{ cursor: 'pointer' }}
            onClick={() => (onChange ? onChange(option) : undefined)}
          >
            <Card.Body>{children(option, selected)}</Card.Body>
          </Card>
        );
      })}
    </>
  );
};

export default SelectItemInput;
